import { CustomerData, Http } from '@pirates/not-morty-biz';

export class CustomerService {
  public async get(customerId: number) {
    const cacheCustomer = this.cache[customerId];
    if (cacheCustomer) {
      return Promise.resolve(cacheCustomer);
    }

    const customer = await Http.get<CustomerData>(`/api/b2b/bo-api/v1/customer/users/${customerId}`);
    this.cache[customerId] = customer;

    return customer;
  }

  private cache: { [key: number]: CustomerData } = {};
}

export const customerService = new CustomerService();
